import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Observable } from 'rxjs';

import { AuthenticationService } from '../../authentication/authentication.service';

@Injectable()
export class ShowDeviceLogsResolver implements Resolve<boolean> {
  constructor(private auth: AuthenticationService) {}

  public resolve(): Observable<boolean> {
    return this.auth.isLoggedInAsPartner$;
  }
}
